const apis = {
    allConsumedApis: [],
    allInternalApis: [],
    allExposedApis: [],
    updatedExposedApi: [],
    newConsumedApi: [],
    startExternalSource: [],
    apiCommitId: null,
    exposedApiCommitId: null
};

export default apis;
